import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage-angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { LayoutModule } from './layout/layout.module';
import { CoreModule } from './core/core.module';
import { ToastrModule } from 'ngx-toastr';
import { LoadingComponent } from './shared/loading/loading.component';
import { OnboardingService } from '@pages/dashboard/services/onboarding.service';
import { OlvidePasswordModule } from '@shared/seguridad/olvide-password/olvide-password.module';
import { DRAWERS_SERVICE } from './shared/drawers/drawers.token';
import { DrawersService } from '@shared/drawers/drawers.service';
import { environment } from 'src/environments/environment';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';

@NgModule({
  declarations: [AppComponent, LoadingComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    IonicModule.forRoot(),
    IonicStorageModule.forRoot(),
    ToastrModule.forRoot(),
    AppRoutingModule,
    LayoutModule,
    OlvidePasswordModule
    
  ],
  providers: [
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy
    },
    OnboardingService,
    { provide: DRAWERS_SERVICE, useExisting: DrawersService }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
 

